<div class="row contenedor-detalle-siniestro mx-1">
    <div class="col-lg-4  col-md-6 col-sm-12 col-12">
        <div class="row borde-inferior">
            <div class="col-md-12 col-12">
                <small class="titulo info-value-fecha-label">SINIESTRO</small>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-12 col-12 info-group mt-2 mb-2">
                <div class="info-row">
                    <small class="titulo info-value-siniestro-label">Siniestro: </small>
                    <strong class="valorTextoWeight-500 info-value-siniestro-value">{{siniestroSeleccionado?.monedak}}-{{siniestroSeleccionado?.ramok}}-{{siniestroSeleccionado?.sramok}}-{{siniestroSeleccionado?.oficinak}}-{{siniestroSeleccionado?.conseck}}-{{siniestroSeleccionado?.aak}} {{siniestro?.desc_monedak}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo info-value-siniestro-label">Agente: </small>
                    <strong class="valorTextoWeight-500 info-value-siniestro-value">{{siniestro?.desc_agente}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo info-value-siniestro-label">Contratante: </small>
                    <strong class="valorTextoWeight-500 info-value-siniestro-value">{{siniestro?.desc_contratante}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo info-value-siniestro-label">Responsable: </small>
                    <strong class="valorTextoWeight-500 info-value-siniestro-value">{{siniestro?.respons_sini == 1 ? 'ASEGURADO' : 'TERCERO'}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo info-value-siniestro-label">Causa: </small>
                    <strong class="valorTextoWeight-500 info-value-siniestro-value">{{siniestro?.desc_causa}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo info-value-siniestro-label">Sub causa: </small>
                    <strong class="valorTextoWeight-500 info-value-siniestro-value">{{siniestro?.desc_sub_causa}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo info-value-siniestro-label">Tipo perdida: </small>
                    <strong class="valorTextoWeight-500 info-value-siniestro-value">{{siniestro?.cve_perdida_total == null ? '' : siniestro?.serie_normal == 1 ? siniestro?.cve_perdida_total == 1 ? 'PARCIAL' : 'TOTAL' : '' }}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo info-value-siniestro-label">Corralón destino: </small>
                    <strong class="valorTextoWeight-500 info-value-siniestro-value">{{siniestro?.corralon_destino}}</strong>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-4  col-md-6 col-sm-12 col-12" [ngClass]="{'borde-izquierdo' : !['xs', 'sm'].includes(screenSize)}">
        <div class="row borde-inferior">
            <div class="col-md-12 col-12">
                <small class="titulo info-value-fecha-label">FECHAS Y HORAS</small>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-12 col-12 info-group mt-2 mb-2">
                <div class="info-row">
                    <small class="titulo info-value-fecha-label">Ocurrido: </small>
                    <strong class="valorTextoWeight-500 info-value" >{{siniestro?.fecsini}}</strong>
                    <strong class="valorTextoWeight-500 info-value-fecha-value">{{siniestro?.horasini}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo info-value-fecha-label">Reclamado: </small>
                    <strong class="valorTextoWeight-500 info-value">{{siniestro?.fecrecla}}</strong>
                    <strong class="valorTextoWeight-500 info-value-fecha-value">{{siniestro?.horarecla}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo info-value-fecha-label">Registrado: </small>
                    <strong class="valorTextoWeight-500 info-value">{{siniestro?.fecreg}}</strong>
                    <strong class="valorTextoWeight-500 info-value-fecha-value">{{siniestro?.horareg}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo info-value-fecha-label">Asignado: </small>
                    <strong class="valorTextoWeight-500 info-value">{{siniestro?.fecaviso}}</strong>
                    <strong class="valorTextoWeight-500 info-value-fecha-value">{{siniestro?.horaviso}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo info-value-fecha-label">Arribo: </small>
                    <strong class="valorTextoWeight-500 info-value">{{siniestro?.feciniatn}}</strong>
                    <strong class="valorTextoWeight-500 info-value-fecha-value">{{siniestro?.horainiatn}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo info-value-fecha-label">Fin atención: </small>
                    <strong class="valorTextoWeight-500 info-value">{{siniestro?.fecfinatn}}</strong>
                    <strong class="valorTextoWeight-500 info-value-fecha-value">{{siniestro?.horafinatn}}</strong>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-4  col-md-12 col-sm-12 col-12" [ngClass]="{'borde-izquierdo' : !['xs', 'sm'].includes(screenSize)}">
        <div class="row borde-inferior">
            <div class="col-md-12 col-12">
                <small class="titulo info-value-fecha-label">ASEGURADO</small>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-12 col-12 info-group mt-2 mb-2">
                <div class="info-row">
                    <small class="titulo info-value-fecha-label">Edad: </small>
                    <strong class="valorTextoWeight-500 info-value">{{siniestro?.edad}}</strong>
                </div>
            </div>
            <!-- Tipo 1 (M) : (F) -->
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo info-value-fecha-label">Sexo: </small>
                    <strong class="valorTextoWeight-500 info-value">{{siniestro?.sexo == 1 ? 'MASCULINO' : 'FEMENINO'}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo info-value-fecha-label">E-mail: </small>
                    <strong class="valorTextoWeight-500 info-value">{{siniestro?.email}}</strong>
                </div>
            </div>
            
        </div>
    </div>
    
</div>